<template>
  <v-card>
    <v-card-title class="grey--text text-subtitle-1">
      Piano di Coltivazione
      <v-spacer></v-spacer>
      <v-btn
        outlined
        color="blue-grey"
        class="mr-2"
        @click="$refs.gestione_tipi_stagione.openDialog()"
      >
        <v-icon class="mr-2">mdi-calendar-multiple</v-icon>
        Tipi Stagione
      </v-btn>
      <v-btn
        outlined
        color="purple"
        class="mr-2"
        @click="$refs.gestione_vasi.openDialog()"
      >
        <v-icon class="mr-2">mdi-bucket-outline</v-icon>
        Gestisci Vasi
      </v-btn>
      <v-btn
        outlined
        color="deep-orange"
        class="mr-2"
        :disabled="!stagione_attiva"
        @click="dialog_confronto = true"
      >
        <v-icon class="mr-2">mdi-compare-horizontal</v-icon>
        Confronto
      </v-btn>
      <v-btn outlined color="green" @click="$refs.nuova_stagione.openDialog()">
        <v-icon class="mr-2">mdi-calendar</v-icon>
        Nuova Stagione
      </v-btn>
      <GestioneTipiStagione ref="gestione_tipi_stagione" />
      <GestioneVasi ref="gestione_vasi" />
      <NuovaStagione ref="nuova_stagione" @stagione-creata="onStagioneCreata" />
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col>
          <v-menu v-if="stagioni_coltivazione.length > 0" bottom left offset-y>
            <template #activator="{ on, attrs }">
              <v-sheet
                outlined
                rounded
                class="py-1 px-3 d-flex align-center"
                style="cursor: pointer;"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="grey" size="20" class="mr-2">mdi-calendar-star</v-icon>
                <div>
                  <div class="caption grey--text">Stagione attiva</div>
                  <div class="text-subtitle-1 font-weight-bold" style="line-height: 1.2;">
                    <span v-if="stagione_attiva" class="green--text"
                      >{{ nomeStagione(stagione_attiva) }}</span
                    >
                    <span v-else>Nessuna stagione selezionata</span>
                  </div>
                </div>
                <v-spacer></v-spacer>
                <v-icon size="18">mdi-menu-down</v-icon>
              </v-sheet>
            </template>
            <v-list>
              <div
                v-for="row in stagioni_dropdown_flat"
                :key="row.type === 'subheader' ? 'hdr-' + row.anno : 'item-' + row.stagione.id"
              >
                <v-subheader v-if="row.type === 'subheader'" class="font-weight-bold">{{ row.anno }}</v-subheader>
                <v-list-item v-else @click="impostaStagioneAttiva(row.stagione)">
                  <v-list-item-title>{{ nomeStagione(row.stagione) }}</v-list-item-title>
                </v-list-item>
              </div>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>

      <v-divider class="my-4"></v-divider>

      <v-row v-if="!stagione_attiva">
        <v-col>
          <v-alert type="info" outlined>
            Non è attiva nessuna stagione di coltivazione. Crea una nuova
            stagione per iniziare a pianificare le coltivazioni.
          </v-alert>
        </v-col>
      </v-row>

      <template v-else>
        <v-tabs v-model="tab_attivo" class="mb-3">
          <v-tab>
            <v-icon small class="mr-1">mdi-sprout</v-icon>Piano
          </v-tab>
          <v-tab>
            <v-icon small class="mr-1">mdi-truck-delivery</v-icon>Arrivi
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab_attivo">
          <v-tab-item>
            <ProdottiPianificatiViewer
              :prodotti="prodotti_stagione_attiva"
              :specie_disponibili="specie_disponibili"
              :contenitori_coltivazione="contenitori_coltivazione"
              :stagione_attiva="stagione_attiva"
              @nuovo-prodotto="apriDialogNuovoProdotto"
              @prodotto-eliminato="onProdottoEliminato"
              @prodotto-modifica-richiesta="onProdottoModificaRichiesta"
              @esporta-piano="onEsportaPiano"
              @collega-tutti="onCollegaTutti"
            />
          </v-tab-item>
          <v-tab-item>
            <CalendarioArriviTab :stagione_attiva="stagione_attiva" />
          </v-tab-item>
        </v-tabs-items>
      </template>

      <v-dialog v-model="dialog_nuovo_prodotto" max-width="980" scrollable>
        <v-card>
          <v-card-title class="text-subtitle-1">
            Nuovo Prodotto Stagione
            <v-spacer></v-spacer>
            <v-btn icon @click="dialog_nuovo_prodotto = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-4">
            <NuovoProdottoForm
              :key="'nuovo-' + nuovo_prodotto_key"
              ref="form_prodotto"
              embedded
              :stagione_attiva="stagione_attiva"
              :specie_disponibili="specie_disponibili"
              :contenitori_coltivazione="contenitori_coltivazione"
              :prodotti_stagione_attiva="prodotti_stagione_attiva"
              :presets="presets_nuovo_prodotto"
              :loading_esterno="loading_salvataggio"
              :error_esterno="errore_salvataggio"
              :success_esterno="feedback_salvataggio.color === 'success' ? feedback_salvataggio.message : ''"
              @prodotto-aggiunto="onProdottoAggiunto"
              @clear-feedback="onClearFeedback"
            />
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackbar_collega_tutti.visible" :color="snackbar_collega_tutti.color" timeout="3000" top>
        {{ snackbar_collega_tutti.message }}
      </v-snackbar>

      <ConfruntoPianoArriviDialog
        v-model="dialog_confronto"
        :prodotti="prodotti_stagione_attiva"
        :stagione_attiva="stagione_attiva"
      />

      <!-- Dialog modifica prodotto -->
      <v-dialog v-model="dialog_modifica_prodotto" max-width="980" scrollable>
        <v-card>
          <v-card-title class="text-subtitle-1">
            Modifica Prodotto
            <v-spacer></v-spacer>
            <v-btn icon @click="dialog_modifica_prodotto = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-4">
            <NuovoProdottoForm
              :key="'modifica-' + (prodotto_in_modifica ? prodotto_in_modifica.id : 'none')"
              ref="form_modifica_prodotto"
              embedded
              :stagione_attiva="stagione_attiva"
              :specie_disponibili="specie_disponibili"
              :contenitori_coltivazione="contenitori_coltivazione"
              :prodotti_stagione_attiva="prodotti_stagione_attiva"
              :prodotto_in_modifica="prodotto_in_modifica"
              :loading_esterno="loading_modifica"
              :error_esterno="errore_modifica"
              :success_esterno="successo_modifica"
              @prodotto-modificato="onProdottoModificato"
              @clear-feedback="onClearFeedbackModifica"
            />
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card-text>
  </v-card>
</template>

<script>
import NuovaStagione from "./nuova_stagione_dialog.vue";
import GestioneVasi from "./gestione_vasi.vue";
import GestioneTipiStagione from "./gestione_tipi_stagione.vue";
import NuovoProdottoForm from "./NuovoProdottoForm.vue";
import ProdottiPianificatiViewer from "./ProdottiPianificatiViewer.vue";
import CalendarioArriviTab from "./CalendarioArriviTab.vue";
import ConfruntoPianoArriviDialog from "./ConfruntoPianoArriviDialog.vue";
import printer from "@/service/printer.js";

export default {
  name: "PianoColtivazioneDesktop",
  components: {
    GestioneVasi,
    GestioneTipiStagione,
    NuovaStagione,
    NuovoProdottoForm,
    ProdottiPianificatiViewer,
    CalendarioArriviTab,
    ConfruntoPianoArriviDialog,
  },
  data() {
    return {
      tab_attivo: 0,
      stagione_attiva: null,
      dialog_confronto: false,
      dialog_nuovo_prodotto: false,
      dialog_modifica_prodotto: false,
      prodotto_in_modifica: null,
      presets_nuovo_prodotto: {},
      nuovo_prodotto_key: 0,
      loading_salvataggio: false,
      errore_salvataggio: "",
      loading_modifica: false,
      errore_modifica: "",
      successo_modifica: "",
      feedback_salvataggio: {
        visible: false,
        color: "success",
        message: "",
      },
      snackbar_collega_tutti: {
        visible: false,
        color: "success",
        message: "",
      },
    };
  },
  mounted() {
    this.bootstrapPianoColtivazione();
  },
  computed: {
    stagioni_coltivazione() {
      return this.$store.getters.getStagioniColtivazione || [];
    },
    contenitori_coltivazione() {
      return this.$store.getters.getContenitoriColtivazione || [];
    },
    specie_disponibili() {
      return this.$store.getters.get_specie || [];
    },
    prodotti_stagione_attiva() {
      if (!this.stagione_attiva || !this.stagione_attiva.id) return [];
      return this.$store.getters.getProdottiPianificazione(this.stagione_attiva.id);
    },
    stagioni_dropdown_flat() {
      const sorted = [...this.stagioni_coltivazione].sort((a, b) => b.anno - a.anno);
      const rows = [];
      let lastAnno = null;
      for (const s of sorted) {
        const anno = s.anno || '—';
        if (anno !== lastAnno) {
          rows.push({ type: 'subheader', anno });
          lastAnno = anno;
        }
        rows.push({ type: 'item', stagione: s });
      }
      return rows;
    },
  },
  methods: {
    nomeStagione(s) {
      if (!s) return '';
      const tipo = s.tipo_stagione?.nome || s.nome || '';
      return `${tipo} ${s.anno}`.trim();
    },
    mostraFeedbackSalvataggio(message, color) {
      this.feedback_salvataggio = {
        visible: true,
        color,
        message,
      };
    },
    apriDialogNuovoProdotto(ctx) {
      this.onClearFeedback();
      this.presets_nuovo_prodotto = ctx || {};
      this.nuovo_prodotto_key++;
      this.dialog_nuovo_prodotto = true;
    },
    onClearFeedback() {
      this.errore_salvataggio = "";
      this.feedback_salvataggio.visible = false;
      this.feedback_salvataggio.message = "";
    },
    bootstrapPianoColtivazione() {
      Promise.all([
        this.$store.dispatch("fetchStagioniColtivazione"),
        this.$store.dispatch("fetchContenitoriColtivazione"),
        this.$store.dispatch("fetch_specie"),
      ]).then(([stagioni]) => {
        const oggi = Math.floor(Date.now() / 1000);
        const stagione = stagioni.find(
          (st) => st.inizio <= oggi && st.fine >= oggi
        );
        this.stagione_attiva = stagione || null;
        if (stagione) {
          this.$store.dispatch("fetchProdottiPianificazione", stagione.id);
        }
      });
    },
    impostaStagioneAttiva(stagione) {
      this.stagione_attiva = stagione;
      this.$store.dispatch("fetchProdottiPianificazione", stagione.id);
    },
    async onProdottoAggiunto(payload) {
      this.loading_salvataggio = true;
      this.errore_salvataggio = "";
      try {
        await this.$store.dispatch("saveProdottoPianificazione", payload);
        this.mostraFeedbackSalvataggio("Prodotto salvato correttamente.", "success");
      } catch (e) {
        this.errore_salvataggio =
          e?.response?.data?.message || "Errore durante il salvataggio.";
        this.mostraFeedbackSalvataggio(this.errore_salvataggio, "error");
      } finally {
        this.loading_salvataggio = false;
      }
    },
    async onProdottoEliminato(id_prodotto) {
      if (!this.stagione_attiva) return;
      try {
        await this.$store.dispatch("deleteProdottoPianificazione", {
          id_stagione: this.stagione_attiva.id,
          id_prodotto,
        });
      } catch {
        this.mostraFeedbackSalvataggio("Errore durante l'eliminazione. Riprova.", "error");
      }
    },
    onStagioneCreata(stagione) {
      this.stagione_attiva = stagione;
      this.$store.dispatch("fetchProdottiPianificazione", stagione.id);
    },
    onProdottoModificaRichiesta(prodotto) {
      this.prodotto_in_modifica = prodotto;
      this.errore_modifica = "";
      this.successo_modifica = "";
      this.dialog_modifica_prodotto = true;
    },
    onClearFeedbackModifica() {
      this.errore_modifica = "";
      this.successo_modifica = "";
    },
    async onProdottoModificato(payload) {
      if (!this.stagione_attiva || !this.prodotto_in_modifica) return;
      this.loading_modifica = true;
      this.errore_modifica = "";
      try {
        await this.$store.dispatch("updateProdottoPianificazione", {
          id_stagione: this.stagione_attiva.id,
          id_prodotto: this.prodotto_in_modifica.id,
          payload,
        });
        const commercialeOriginale = this.prodotto_in_modifica.id_prodotto_commerciale || null;
        const commercialeNuovo = payload.id_prodotto_commerciale || null;
        if (commercialeNuovo !== commercialeOriginale) {
          await this.$store.dispatch("linkProdottoCommerciale", {
            id_stagione: this.stagione_attiva.id,
            id_prodotto: this.prodotto_in_modifica.id,
            id_prodotto_commerciale: commercialeNuovo,
          });
        }
        this.successo_modifica = "Prodotto aggiornato correttamente.";
        setTimeout(() => {
          this.dialog_modifica_prodotto = false;
          this.prodotto_in_modifica = null;
        }, 1200);
      } catch (e) {
        this.errore_modifica = e?.response?.data?.message || "Errore durante l'aggiornamento.";
      } finally {
        this.loading_modifica = false;
      }
    },
    async onCollegaTutti({ id_prodotti, id_prodotto_commerciale }) {
      if (!this.stagione_attiva) return;
      const results = await Promise.allSettled(
        id_prodotti.map((id_prodotto) =>
          this.$store.dispatch("linkProdottoCommerciale", {
            id_stagione: this.stagione_attiva.id,
            id_prodotto,
            id_prodotto_commerciale,
          })
        )
      );
      const failed = results.filter((r) => r.status === "rejected").length;
      const ok = id_prodotti.length - failed;
      this.snackbar_collega_tutti = {
        visible: true,
        color: failed === 0 ? "success" : failed === id_prodotti.length ? "error" : "warning",
        message: failed === 0
          ? `${ok} prodott${ok === 1 ? "o collegato" : "i collegati"} correttamente.`
          : `${ok} collegat${ok === 1 ? "o" : "i"}, ${failed} falliti.`,
      };
    },
    onEsportaPiano() {
      if (!this.stagione_attiva) return;
      printer.print_pdf_piano_stagione({ id_stagione: this.stagione_attiva.id });
    },
  },
  beforeDestroy() {},
};
</script>
